import { render, staticRenderFns } from "./companyItemList.vue?vue&type=template&id=7bf188f2&scoped=true"
import script from "./companyItemList.vue?vue&type=script&lang=js"
export * from "./companyItemList.vue?vue&type=script&lang=js"
import style0 from "./companyItemList.vue?vue&type=style&index=0&id=7bf188f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf188f2",
  null
  
)

export default component.exports